import { WithStyles, withStyles } from '@material-ui/core';
import React from 'react';
import styles from './Autocomplete.styles';
import Autocomplete, { AutocompleteProps } from './Autocomplete';

interface Props extends AutocompleteProps {
  classes?: Partial<WithStyles<typeof styles>['classes']>;
}

export default withStyles(styles)(Autocomplete) as React.ComponentClass<Props>;
